module.exports = __webpack_public_path__ + "img/aParty_110923_B.058f7525.jpg";